import { Link } from 'react-router-dom';

const SERVICES_LINKS = [
  { label: 'Flooring Installation', path: '/flooring-installation' },
  { label: 'Dustless Demolition', path: '/contact' },
  { label: 'Subfloor Prep & Leveling', path: '/contact' },
  { label: 'Bathroom Remodeling', path: '/bathroom-remodeling' },
];

const QUICK_LINKS = [
  { label: 'Home', path: '/' },
  { label: 'Flooring Installation', path: '/flooring-installation' },
  { label: 'Bathroom Remodeling', path: '/bathroom-remodeling' },
  { label: 'Our Work', path: '/portfolio' },
  { label: 'Get a Free Estimate', path: '/contact' },
];

export default function Footer() {
  return (
    <footer className="bg-[#2d2926] border-t border-[#3d3936]">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <img
              src="https://public.readdy.ai/ai/img_res/8342d37a-c42b-426f-8471-3ee98b8a5f57.png"
              alt="VM General Construction LLC"
              className="h-16 w-auto object-contain mb-4"
            />
            <p className="text-[#9c9490] text-sm leading-relaxed">
              Professional flooring, dustless demolition, and remodeling services across Tampa Bay & Sarasota.
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="https://www.facebook.com/share/1HyzwJ7c8i/?mibextid=wwXIfr" target="_blank" rel="nofollow noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full border border-[#5d5956] text-[#9c9490] hover:text-[#c9a55a] hover:border-[#c9a55a] transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-sm" />
              </a>
              <a href="https://www.instagram.com/vm_construction?igsh=MWppd2IwNml4dGFreA%3D%3D&utm_source=qr" target="_blank" rel="nofollow noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full border border-[#5d5956] text-[#9c9490] hover:text-[#c9a55a] hover:border-[#c9a55a] transition-colors cursor-pointer">
                <i className="ri-instagram-line text-sm" />
              </a>
              <a href="mailto:vmofficeconstruction@gmail.com" rel="nofollow noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full border border-[#5d5956] text-[#9c9490] hover:text-[#c9a55a] hover:border-[#c9a55a] transition-colors cursor-pointer">
                <i className="ri-google-fill text-sm" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-[#f4f0ea] font-semibold text-sm uppercase tracking-widest mb-5">
              Services
            </h4>
            <ul className="space-y-3">
              {SERVICES_LINKS.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-[#9c9490] hover:text-[#c9a55a] text-sm transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-[#f4f0ea] font-semibold text-sm uppercase tracking-widest mb-5">
              <a href="/">Quick Links</a>
            </h4>
            <ul className="space-y-3">
              {QUICK_LINKS.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-[#9c9490] hover:text-[#c9a55a] text-sm transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-[#f4f0ea] font-semibold text-sm uppercase tracking-widest mb-5">
              <a href="/contact">Contact</a>
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-line text-[#c9a55a] text-base" />
                </div>
                <span className="text-[#9c9490] text-sm leading-relaxed">
                  Tampa Bay & Sarasota, Florida
                </span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-phone-line text-[#c9a55a] text-base" />
                </div>
                <a href="tel:+19044019383" className="text-[#9c9490] hover:text-[#f4f0ea] text-sm transition-colors cursor-pointer">
                  (904) 401-9383
                </a>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-mail-line text-[#c9a55a] text-base" />
                </div>
                <a href="mailto:vmofficeconstruction@gmail.com" className="text-[#9c9490] hover:text-[#f4f0ea] text-sm transition-colors cursor-pointer">
                  vmofficeconstruction@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#3d3936] mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-[#9c9490]/60 text-xs">
            © {new Date().getFullYear()} VM General Construction LLC. All rights reserved.
          </p>
          <p className="text-[#9c9490]/60 text-xs">
            Fully Insured • Licensed • Serving Tampa Bay & Sarasota
          </p>
        </div>
      </div>
    </footer>
  );
}
